import { Array, Boolean, Record, String, Unknown } from 'runtypes';

export const MessageExtrasRunType = Record({
	hasMultipleReceivers: Boolean,
	otherReceiversOfThisMessage: Array(Unknown).Or(String),
});
